import { useState } from "react";
import "./home.css";

const STEPS = [
  {
    num: 1,
    icon: "fa-file-pen",
    title: "Register Through Our Website",
    desc: "Quick and easy registration to get started.",
  },
  {
    num: 2,
    icon: "fa-id-card",
    title: "Update Your KYC Details",
    desc: "Complete your KYC securely in just a few minutes.",
  },
  {
    num: 3,
    icon: "fa-envelope",
    title: "Get Your Login Credentials",
    desc: "Receive your login details within 24 working hours.",
  },
  {
    num: 4,
    icon: "fa-chart-line",
    title: "Track and Grow",
    desc: "Track your investments and grow your wealth with confidence.",
  },
];

export default function HowItWorks() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("Thanks! We'll keep you updated.");
    setEmail("");
  };

  return (
    <section className="gps-how">
      <div className="gps-how-inner">
        <header className="gps-how-header">
          <p className="gps-how-eyebrow">HOW IT WORKS</p>
          <h2 className="gps-how-title">Your Journey to Financial Growth</h2>
        </header>

        <ol className="gps-how-steps">
          {STEPS.map((step, i) => (
            <li key={step.num} className="gps-how-step">
              <div className="gps-how-icon-wrap">
                <div className="gps-how-icon">
                  <i className={`fa-solid ${step.icon}`} aria-hidden="true" />
                </div>
                <span className="gps-how-num">{step.num}</span>
              </div>
              <h3 className="gps-how-step-title">{step.title}</h3>
              <p className="gps-how-step-desc">{step.desc}</p>
              {i < STEPS.length - 1 && (
                <span className="gps-how-arrow" aria-hidden="true">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>

        <div className="gps-newsletter">
          <div className="gps-newsletter-left">
            <div className="gps-newsletter-icon" aria-hidden="true">
              <i className="fa-solid fa-envelope" />
            </div>
            <div className="gps-newsletter-copy">
              <h3 className="gps-newsletter-title">
                Stay Ahead with Market Insights
              </h3>
              <p className="gps-newsletter-desc">
                Subscribe to get the latest market updates, investment tips, and
                exclusive opportunities.
              </p>
            </div>
          </div>

          <form className="gps-newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-label="Email address"
            />
            <button type="submit">Subscribe</button>
          </form>
          {status ? (
            <p className="gps-newsletter-status" role="status">
              {status}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
